export default "https://cdn-static.gokick.com/assets/510b01776e4307c2b342e37a2ed4ce502ef69aad/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";